import ChevronLeft from 'components/Icons/ChevronLeft';
import React from 'react';
import { Doc } from 'records/Doc';
import withAppStore, { WithAppStoreProps } from 'utils/withAppStore';

interface Props extends WithAppStoreProps {
  doc: Doc;
  onNavBackClick: (event: React.MouseEvent) => void;
}

class ViewerHeader extends React.Component<Props> {
  render(): React.ReactNode {
    const { doc } = this.props;

    return (
      <div className="hs3 w100 bb-1 row justify-between shrink-0">
        <div className="row items-center">
          <div
            className="flex-center"
            style={{ width: '56px', borderColor: '#ced1d1' }}
          >
            <div
              className="hrem-2 wrem-2 flex-center fill-primary cursor-pointer"
              onClick={this.props.onNavBackClick}
            >
              <ChevronLeft width="12px" height="22px" />
            </div>
          </div>
          <div
            className="hrem-1p5 br-solid br-width-1"
            style={{ borderColor: '#ced1d1' }}
          />
          <div className="row font-size-4 color-gray-8 ml3 items-center">
            <div className="mr3 color-primary nowrap truncate">
              {doc.filename}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppStore<Props>(ViewerHeader);
